
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsuarioSunQuery"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"usuario"},"name":{"kind":"Name","value":"usuarioSun"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"us_id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"nome"},"name":{"kind":"Name","value":"us_nome"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"regionais"},"name":{"kind":"Name","value":"reag_all"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"regionaisAcesso"},"name":{"kind":"Name","value":"regionais"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reg_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reg_descricao"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uf_all"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"admin"},"name":{"kind":"Name","value":"us_admin"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"filiais"},"name":{"kind":"Name","value":"filiais_acesso"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"fiag_id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"nome"},"name":{"kind":"Name","value":"fiag_nome_fantasia"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"razao"},"name":{"kind":"Name","value":"fiag_razao_social"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"codigoDealer"},"name":{"kind":"Name","value":"fiag_cod_dealer"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"acesso"},"name":{"kind":"Name","value":"siglas_acesso"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uf"},"name":{"kind":"Name","value":"uf_sigla"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"uf_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regional"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"reg_id"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"funcao"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"fun_id"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"nome"},"name":{"kind":"Name","value":"fun_nome"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":535}};
    doc.loc.source = {"body":"query UsuarioSunQuery {\n  usuario: usuarioSun {\n    id: us_id\n    nome: us_nome\n    regionais: reag_all\n    regionaisAcesso: regionais {\n      reg_id\n      reg_descricao\n    }\n    uf_all\n    admin: us_admin\n    filiais: filiais_acesso {\n      id: fiag_id\n      nome: fiag_nome_fantasia\n      razao: fiag_razao_social\n      codigoDealer: fiag_cod_dealer\n    }\n    acesso: siglas_acesso {\n      uf: uf_sigla\n      id: uf_id\n      regional {\n        id: reg_id\n      }\n    }\n    funcao {\n      id: fun_id\n      nome: fun_nome\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["UsuarioSunQuery"] = oneQuery(doc, "UsuarioSunQuery");
        
